import { collection, getFirestore, onSnapshot } from 'firebase/firestore'
import React, {  useEffect, useState } from 'react'
import { currentUser } from '../../util/currentUser'
import { app } from '../../util/firebase'

export default function Panier() {

    const [panier, setPanier] = useState([])

    useEffect(() => {
        onSnapshot(collection(getFirestore(app), "commandesClient"),(snap)=>{
            setPanier(snap.docs.map((commande)=> commande.data()))
        })
    }, [])
    
    const listPanier = ()=>{
        return panier.filter((commande)=>commande.user.email === currentUser.email)
        .map((commande,id)=>{
            return(
                <div className="col-md-3 mt-3 col-sm-6 " key={id}>
                    <div className="card bg-light">
                    <div className='bg-dark' style={{backgroundImage: "url("+commande.imgSrc_commande+")",minHeight:"150px", backgroundSize:"cover", backgroundRepeat:"no-repeat"}}>
                        
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                            <p className="small"><a href="#!" className="text-muted">Pharmcie: </a></p>
                            <p className="small">Arafat</p>
                            </div>

                            <div className="d-flex justify-content-between">
                            <p >{commande.name_commande}</p>
                            <span className="text-dark mb-0">{commande.price_commande} FCFA</span>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }


    return (
        <div className="row">
            {listPanier()}
        </div>
    )
    }
